import React, { useState } from 'react';
import { Button, Card, Modal } from 'components/common'
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';
import { useDispatch } from 'react-redux';
import { assignContact } from 'redux/crm/contactSlice';

import { FaBan, FaUser } from 'react-icons/fa';
import { salesEmployeesByNameDebounce } from 'helpers/employeeOptionHelper';
import PropTypes from 'prop-types';

const AssignContactModal = ({showModal, setshowModal, contactId}) => {
  const [formData, setFormData] = useState([]);
  const dispatch = useDispatch();

  const loadEmpOptions = (inputValue, callback) => {
    salesEmployeesByNameDebounce(inputValue, callback);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = [];
    formData && formData.forEach((item) => data.push(item.label));

    try {
      await dispatch(assignContact({contactId, formData: { name: data} }));
      setshowModal(false);
    }
    catch(error) {
      toast.error(error.message);
    }
  }

  const handleCancel = () => {
    setshowModal(false);
  }

  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      title='Assigned contact'
      backdropClick={false}
      footer={(
        <>
          <Button size='sm' type='submit' variant='primary' form='assign-contact-form'><FaUser /> Assign</Button>
          <Button size='sm' variant='danger' onClick={handleCancel}><FaBan /> Cancel</Button>
        </>
      )}
    >
      <form id='assign-contact-form' onSubmit={handleSubmit}>
        <h6 className='tw-text-blue-600 tw-mb-2'>Specify name to assign for this contact</h6>
        <Card bordered className='tw-text-sm'>
          <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={loadEmpOptions}
            closeMenuOnSelect={false}
            placeholder='Select...'
            classNamePrefix='react-select'
            className='tw-w-full'
            name='name'
            isMulti
            required
            onChange={setFormData}
          />
        </Card>
      </form>
    </Modal>
  ) ;
};

AssignContactModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  contactId: PropTypes.number.isRequired
}

export default AssignContactModal;
